// extracted by mini-css-extract-plugin
export default {"container":"BottomTray_container__+bXUN","badgeIndex":"BottomTray_badgeIndex__zBuKb"};